import type { CityConfig } from "../city-template/types";

export const schaumburgConfig: CityConfig = {
  city: "Schaumburg",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "schaumburg",
  route: "/schaumburg",
  title: "Emergency Passport Schaumburg, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Schaumburg, Illinois — as fast as 24 hours. Fast passport renewal and new passport applications for Motorola, Zurich Insurance, Woodfield area corporate travelers, and all northwest suburban residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Schaumburg, IL",
  heroSubtitle: "Zurich Insurance executive with a London meeting next week? Motorola Solutions engineer deploying to Asia with expired documents? Woodfield area family vacation to Europe with two weeks notice? We help Schaumburg residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Chicago's northwest suburbs.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Schaumburg%20Illinois%20northwest%20Chicago%20suburb%20panoramic%20skyline%20with%20modern%20corporate%20office%20buildings%20and%20Woodfield%20Mall%20area%2C%20tree-lined%20suburban%20landscape%2C%20corporate%20campuses%20along%20I-90%20corridor%2C%20warm%20afternoon%20golden%20light%20illuminating%20modern%20glass%20architecture%2C%20professional%20cityscape%20photography%2C%20affluent%20suburban%20Chicago%20business%20district%20atmosphere&width=1800&height=700&seq=schaumburg-hero-001&orientation=landscape",
  heroImageAlt: "Schaumburg Illinois northwest Chicago suburb with corporate campuses and Woodfield area skyline",
  geoPosition: "42.0334;-88.0834",
  geoPlacename: "Schaumburg, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 35 minutes southeast of Schaumburg via I-90 and I-290",
  },
  nearbyCitiesZips: [
    { name: "Schaumburg", zips: "60159, 60173, 60193, 60194, 60195" },
    { name: "Hoffman Estates", zips: "60169, 60192, 60179" },
    { name: "Palatine", zips: "60067, 60074" },
    { name: "Arlington Heights", zips: "60004, 60005" },
    { name: "Rolling Meadows", zips: "60008" },
    { name: "Elk Grove Village", zips: "60007, 60009" },
    { name: "Hanover Park", zips: "60133" },
    { name: "Streamwood", zips: "60107" },
    { name: "Roselle", zips: "60172" },
    { name: "Bloomingdale", zips: "60108" },
    { name: "Itasca", zips: "60143" },
    { name: "Wood Dale", zips: "60191" },
    { name: "Mount Prospect", zips: "60056" },
    { name: "Des Plaines", zips: "60016, 60017, 60018" },
    { name: "Barrington", zips: "60010, 60011" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — no 35-minute drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Corporate Travel Hub", desc: "Serving Motorola Solutions, Zurich Insurance, and I-90 corridor businesses" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown Chicago required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Arlington Heights, IL", route: "/illinois" },
    { name: "Emergency passport help in Chicago, IL", route: "/chicago" },
    { name: "Fast passport in Naperville, IL", route: "/naperville" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Schaumburg, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (35 minutes southeast via I-90) — without you making the trip. Schaumburg residents can ship from any UPS or FedEx in the northwest suburbs.",
  fpcOfficeDistance: "Serving Schaumburg, Hoffman Estates, Palatine, Arlington Heights, Rolling Meadows, Elk Grove Village, Hanover Park, Streamwood, Roselle, Bloomingdale, Itasca, Wood Dale, Mount Prospect, Des Plaines, and all northwest Cook County suburbs",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Schaumburg and Chicago's northwest suburbs. From the Woodfield Mall retail corridor and the corporate campuses along I-90 to the family neighborhoods of Hoffman Estates and the manufacturing communities of Elk Grove Village, from the bustling commercial districts of Rolling Meadows to the quiet suburbs of Roselle and Itasca — we serve the entire northwest Chicago suburban region.",
  nearbyCitiesIntro: "We serve Schaumburg and all nearby communities including Hoffman Estates, Palatine, Arlington Heights, Rolling Meadows, Elk Grove Village, Hanover Park, Streamwood, Roselle, Bloomingdale, Itasca, Wood Dale, Mount Prospect, Des Plaines, and Barrington. We also serve all northwest Cook County and eastern Kane County communities.",
  howItWorksIntro: "Most Schaumburg travelers complete everything online and ship documents overnight. No need to drive 35 minutes to downtown Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Schaumburg is the largest economic hub in Illinois outside Chicago, with major corporate headquarters and thousands of international business travelers. Here are the most common passport mistakes we see from northwest suburban professionals.",
  testimonialsIntro: "Schaumburg travelers — from Zurich Insurance executives and Motorola Solutions engineers to Woodfield area families and I-90 corridor professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Schaumburg, IL? Here are the most common ones we hear from northwest suburban travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No drive to downtown Chicago required", "Perfect for corporate travel and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 35 minutes to downtown Chicago", "Full day commitment — parking and downtown navigation"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Schaumburg travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 35 minutes away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "Northwest suburban corporate and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Schaumburg adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Schaumburg address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Schaumburg residents — including I-90 corporate professionals, new citizens, and northwest suburban families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Schaumburg residents who lost their passport before international business travel or vacation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Schaumburg and northwest suburban families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Schaumburg and northwest suburban residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Schaumburg IL", description: "Urgent passport processing for Schaumburg Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Schaumburg IL", description: "Fast passport renewal for Schaumburg Illinois residents with a previously-issued passport." },
    { name: "First-Time Passport Schaumburg IL", description: "New passport application services for Schaumburg Illinois residents applying for their first passport." },
    { name: "Child Passport Schaumburg IL", description: "Minor passport services for Schaumburg Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "David L.",
      location: "Schaumburg, IL",
      rating: 5,
      text: "Zurich Insurance sent me to Switzerland with 6 days notice. My passport expired 2 months ago. Fast Passport Center had my renewal in 32 hours. Shipped from the UPS near Woodfield and the whole process was seamless. Corporate travel at its finest.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Priya S.",
      location: "Hoffman Estates, IL",
      rating: 5,
      text: "Family trip to India with our two kids. Two adult renewals and a first-time passport for our daughter. Fast Passport Center got all three done in 4 days. The dedicated agent handled everything — we didn't miss a single detail. Amazing for northwest suburban families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Tom R.",
      location: "Schaumburg, IL",
      rating: 5,
      text: "Motorola Solutions deployment to Singapore came through with 8 days notice. Fast Passport Center processed my new passport in 3 days. I shipped from FedEx on Golf Road and never had to take a day off. Essential for I-90 corridor professionals.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "sch-1",
      name: "Schaumburg Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "450 W Schaumburg Rd",
      city: "Schaumburg",
      state: "IL",
      zip: "60194",
      phone: "(847) 882-4713",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Schaumburg, near Woodfield area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Schaumburg acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Woodfield Mall and corporate campuses.",
      icon: "ri-mail-line",
    },
    {
      id: "sch-2",
      name: "Hoffman Estates Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "990 W Golf Rd",
      city: "Hoffman Estates",
      state: "IL",
      zip: "60169",
      phone: "(847) 884-2950",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hoffman Estates, approximately 5 miles west of Schaumburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hoffman Estates, western Schaumburg. Near Barrington Road corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "sch-3",
      name: "Palatine Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "35 W Wood St",
      city: "Palatine",
      state: "IL",
      zip: "60067",
      phone: "(847) 358-1635",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Palatine, approximately 7 miles north of Schaumburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Palatine, northern Schaumburg. Convenient to Palatine Metra station.",
      icon: "ri-mail-line",
    },
    {
      id: "sch-4",
      name: "Arlington Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "909 W Euclid Ave",
      city: "Arlington Heights",
      state: "IL",
      zip: "60005",
      phone: "(847) 398-3450",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Arlington Heights, approximately 6 miles northeast of Schaumburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Arlington Heights, Rolling Meadows. Good alternative for eastern Schaumburg residents.",
      icon: "ri-mail-line",
    },
    {
      id: "sch-5",
      name: "Elk Grove Village Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "555 W Oakton St",
      city: "Elk Grove Village",
      state: "IL",
      zip: "60007",
      phone: "(847) 439-3830",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Elk Grove Village, approximately 8 miles east of Schaumburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Elk Grove Village, Itasca, and southeastern Schaumburg. Near O'Hare corridor.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35 min drive to downtown Chicago", fpc: "No — ship from Schaumburg" },
    { feature: "Parking & Navigation", agency: "Downtown Chicago parking costs", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Corporate Travel Short Notice",
      description: "Schaumburg's corporate professionals often get 5–7 day notice for international meetings. Standard passport processing takes 6–13 weeks. Our courier service bridges this gap with 24–48 hour turnaround.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Woodfield sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background, no shadows, neutral expression.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or incorrect form type cause rejections at Schaumburg area acceptance facilities. Corporate travelers with name changes need to verify which form applies before their appointment.",
    },
    {
      icon: "ri-global-line",
      title: "Visa-Specific Passport Requirements",
      description: "Many I-90 corridor business travelers need visas for destinations like China, India, and Brazil. These often require at least two blank visa pages and 6 months passport validity. Check before applying.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Trip to Chicago",
      description: "Many Schaumburg residents attempt the drive to the Chicago Passport Agency in an emergency. The 35-minute drive plus downtown parking means a half-day commitment. Our courier service is faster and more reliable.",
    },
    {
      icon: "ri-checkbox-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Northwest suburban corporate travel peaks September–November and January–March — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Schaumburg or the northwest suburbs." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Woodfield or I-90 corridor." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — experienced with corporate travel and family vacation documentation." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 35 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Schaumburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Schaumburg, IL?", a: "Fast Passport Center offers emergency passport processing in Schaumburg, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (35 minutes southeast via I-90) — without you making the trip." },
    { q: "Does Schaumburg have its own passport agency?", a: "No — Schaumburg does not have a regional passport agency. The nearest facility is the Chicago Passport Agency (approximately 35 minutes southeast via I-90 and I-290). Fast Passport Center's courier service means Schaumburg residents never need to make the trip." },
    { q: "Can I get an expedited passport in Hoffman Estates, Palatine, or Elk Grove Village?", a: "Absolutely. Fast Passport Center serves all of Chicago's northwest suburbs including Hoffman Estates, Palatine, Arlington Heights, Rolling Meadows, Elk Grove Village, Hanover Park, Streamwood, Roselle, and all northwest Cook County communities. Our service works the same way everywhere." },
    { q: "Does Fast Passport Center serve Motorola Solutions and Zurich Insurance?", a: "Yes. Fast Passport Center serves corporate travelers from Motorola Solutions, Zurich Insurance, and all major employers along the I-90 corridor. We understand corporate travel schedules, short-notice international meetings, and visa requirements. Our courier service is designed for busy professionals." },
    { q: "What airport do Schaumburg travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is the primary airport for Schaumburg and northwest suburban travelers. O'Hare is approximately 20 minutes east via I-90 and offers direct international flights worldwide. Chicago Midway (MDW) is approximately 45 minutes southeast." },
    { q: "Where can I get passport photos in Schaumburg?", a: "Walgreens, CVS, and UPS Store locations throughout Schaumburg, Hoffman Estates, and Palatine offer passport photos. FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Can I get a passport for my child in Schaumburg?", a: "Yes. Fast Passport Center provides child passport services for minors under 16 throughout Schaumburg and the northwest suburbs. Both parents or legal guardians must typically be present at the acceptance facility, and we guide you through the entire process." },
    { q: "How much does an expedited passport cost in Schaumburg, IL?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
  ],
  photoLocations: [
    { name: "Walgreens — Schaumburg", address: "1301 N Roselle Rd, Schaumburg, IL 60195", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Schaumburg", address: "110 W Higgins Rd, Schaumburg, IL 60195", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Schaumburg", address: "1225 E Golf Rd, Schaumburg, IL 60173", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Hoffman Estates", address: "1012 N Roselle Rd, Hoffman Estates, IL 60169", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Schaumburg", address: "1227 E Golf Rd, Schaumburg, IL 60173", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Online reservations strongly recommended. Convenient to Woodfield and I-90.", featured: true },
    { name: "Illinois SOS — Elgin", address: "595 S State St, Elgin, IL 60123", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Elgin, western Schaumburg area. Full REAL ID processing available.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Cook County birth and death certificates" },
    { label: "Marriage Licenses (Cook County Clerk)", url: "https://www.cookcountyclerk.com/service/marriage-licenses", desc: "Cook County Clerk — marriage license applications and certified copies for Schaumburg and northwest suburbs" },
    { label: "Divorce Decrees (Cook County Circuit Clerk)", url: "https://www.cookcountyclerkofcourt.org/", desc: "Cook County Circuit Clerk — divorce decree records for Schaumburg and Cook County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 20 minutes east via I-90",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Schaumburg and northwest suburban travelers. One of the world's busiest airports with direct flights worldwide. United and American Airlines hub. Extremely convenient from Schaumburg — just a straight shot down I-90.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 45 minutes southeast via I-290 and I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub with domestic connections. Good for travelers flying Southwest to connect to international destinations.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};